<div class="px-24px max-mobile:p-6px">
	<img
		(click)="closeDialog()"
		class="ml-auto cursor-pointer"
		src="./assets/images/close-square.svg"
		alt=""
	/>
	<img class="m-auto mb-24px" [src]="data.image" alt="" />
	<h1
		class="text-font-18 font-DIN-bold font-bold text-dark-grey text-center mb-1"
	>
		{{
			data?.status == 'add'
				? ('WALLET.REASON_POPUP.ADDED_FUND' | translate)
				: ('WALLET.REASON_POPUP.SUBTRACT_FUND' | translate)
		}}
	</h1>
	<div class="m-auto text-center mb-3">
		<span
			class="whitespace-nowrap text-[#00BA88] bg-[#E2F5EE] text-font-[14px] spanst-disc text-center rounded-[50px] inline-block py-1 px-[6px]"
		>
			<span
				class="w-[5px] h-[5px] bg-[#00BA88] rounded inline-block align-middle"
			></span>

			{{ 'STATUS.' + data?.availability | translate }}
		</span>
	</div>
	<div>
		<p class="text-dark-grey text-center text-font-14 break-words">
			{{ data?.reason }}
		</p>
		<div
			mat-button
			(click)="closeDialog()"
			class="w-full bg-gradient text-off-white text-font-14 rounded-6px mt-10 py-[10px] px-[24px] text-center"
		>
			{{ 'GENERAL_LABELS.DONE' | translate }}
		</div>
	</div>
</div>
